import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { philadelphiaConfig } from "./data";

export default function PhiladelphiaPage() {
  return <CityPageTemplate config={philadelphiaConfig} />;
}